module.exports = __webpack_public_path__ + "static/img/IMG_20161028_220002.e4bd132d.jpg";